import React, { useState } from 'react'
import './Music_option_modal.css'
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { Link } from 'react-router-dom';
import Music_play_modal from '../music-play-modal/Music_play_modal';
import Successfull_Modal from '../common-modal/successfull_modal/Successfull_Modal';
import { encodeId } from '../../../../utils/common';

const Music_option_modal = ({ music, musicList, ...props }) => {
    const [playModal, setPlayModal] = useState(false);
    const [successModal, setSuccessModal] = useState(false);


    const handleShare = async () => {
        const shareUrl = `${window.location.origin}/all-album-chants/${encodeId(music?.Chant_Type?.id)}`;

        const shareData = {
            title: music?.name,
            text: `Listen to "${music?.name}" from ${music?.Chant_Type?.name}`,
            url: shareUrl,
        };

        try {
            if (navigator.share) {
                await navigator.share(shareData);
            } else {
                await navigator.clipboard.writeText(shareUrl);
                alert("Link copied to clipboard!");
            }
        } catch (error) {
            console.error("Sharing failed:", error);
        }
    };


    return (
        <>
            <Modal
                {...props}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                className='Music_option_modal'
            >
                <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title-vcenter">
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <h4 className='musname'>{music?.name || " "}</h4>
                    <p className='musdetail'>{music?.Chant_Type?.name || " "}</p>

                    <div className='optionflex'>
                        <div className='box'>
                            <div className='boxflex'
                                // onClick={() => setPlayModal(true)} 
                                onClick={() => { setPlayModal(true); props.onHide(); }}>
                                <div className='icondiv'>
                                    <img className='icon' src={process.env.PUBLIC_URL + '/assets/images/icons/play.png'} />
                                </div>
                                <p className='name'>Play</p>
                            </div>
                        </div>

                        <div className='box' onClick={() => { props.onHide(); }}>
                            <Link to={`/all-album-chants/${encodeId(music?.Chant_Type?.id)}`}>
                                <div className='boxflex'>
                                    <div className='icondiv'>
                                        <img className='icon' src={process.env.PUBLIC_URL + '/assets/images/icons/om.png'} />
                                    </div>
                                    <p className='name'>Go to Album</p>
                                </div>
                            </Link>
                        </div>

                        {/* <div className='box'
                            onClick={() => { setSuccessModal(true); props.onHide(); }}>
                            <div className='boxflex'>
                                <div className='icondiv'>
                                    <img className='icon' src={process.env.PUBLIC_URL + '/assets/images/icons/add.png'} />
                                </div>
                                <p className='name'>Add to My Chants</p>
                            </div>
                        </div> */}
                        <div className='box' onClick={handleShare}>
                            <div className='boxflex'>
                                <div className='icondiv'>
                                    <img
                                        className='icon'
                                        src={process.env.PUBLIC_URL + '/assets/images/icons/share.png'}
                                        alt="Share"
                                    />
                                </div>
                                <p className='name'>Share</p>
                            </div>
                        </div>

                    </div>
                </Modal.Body>
            </Modal >


            <Music_play_modal
                music={music}
                musicList={musicList}
                show={playModal}
                onHide={() => setPlayModal(false)}
            />

            <Successfull_Modal
                show={successModal}
                onHide={() => setSuccessModal(false)}
                headtext={'Chant Adding to Album'}
                successfultext={'Successfully added to your chant list.'}
                subtext={'Have a nice time ahead'}
            />
        </>
    )
}

export default Music_option_modal